'use strict';
define([], function () {
    function controller(
        $scope,
        $translate,
        $mdToast,
        CountriesService,
        TrackEventService,
        $rootScope,
    ) {
        var ctrl = this;
        var vm = $scope;

        vm.planReady = false;
        vm.planError = false;
        vm.searchEngines = [
            {id: 1, name: 'Google', icon: '/assets/img/brand-google.svg'},
            {id: 2, name: 'Yahoo', icon: '/assets/img/brand-yahoo.svg'},
            {id: 4, name: 'Bing', icon: '/assets/img/brand-bing.svg'}
        ];
        vm.devices = [
            {id: 1, name: 'Desktop'},
            {id: 2, name: 'Mobile'}
        ];
        vm.deviceOptions = [
            {value: 1, label: 'Desktop', icon: 'ti-device-desktop'},
            {value: 2, label: 'Mobile', icon: 'ti-device-mobile'}
        ];
        ctrl.deviceOptions = vm.deviceOptions;
        vm.locationDraft = {
            searchEngineId: 1,
            countryCode: null,
            deviceIds: [1, 2]
        };
        vm.countryPickerSearch = '';

        vm.availableCountries = availableCountries;
        vm.pickerCountries = pickerCountries;
        vm.selectCountryFromPicker = selectCountryFromPicker;
        vm.addLocation = addLocation;
        vm.removeLocation = removeLocation;
        vm.countryName = countryName;
        vm.countryFlag = countryFlag;
        vm.locationEngine = locationEngine;
        vm.locationDevice = locationDevice;
        vm.searchEngineIcon = searchEngineIcon;
        vm.toggleDevice = toggleDevice;
        vm.deviceSelected = deviceSelected;
        vm.isLimitExceeded = isLimitExceeded;
        vm.canAddLocation = canAddLocation;
        vm.totalTracking = totalTracking;
        vm.remainingTracking = remainingTracking;
        vm.retryLimits = function () {
            ctrl.onRetryLimits();
        };

        ctrl.$onInit = function () {
            ctrl.locations = ctrl.locations && ctrl.locations.length ? ctrl.locations : [{
                searchEngineId: 1,
                countryCode: 'IT',
                deviceId: 1
            }];
            vm.locations = ctrl.locations;
            vm.planReady = !!ctrl.planReady;
            vm.planError = !!ctrl.planError;
            vm.locationDraft.countryCode = preferredCountryCode();

            vm.$watchCollection(function () { return ctrl.locations; }, function (locations) {
                vm.locations = locations || [];
                if (!vm.locationDraft.countryCode) {
                    vm.locationDraft.countryCode = preferredCountryCode();
                }
            });
            vm.$watch('locationDraft.searchEngineId', function () {
                if (Number(vm.locationDraft.searchEngineId) === 2) {
                    vm.locationDraft.deviceIds = [1];
                }
                if (!vm.locationDraft.countryCode) {
                    vm.locationDraft.countryCode = preferredCountryCode();
                }
            });
            vm.$watch(function () { return ctrl.planReady; }, function (ready) {
                vm.planReady = !!ready;
            });
            vm.$watch(function () { return ctrl.planError; }, function (error) {
                vm.planError = !!error;
            });

            trackStepView();
        };

        function trackStepView() {
            var stoTool = 'SEO Project';
            var eventLabel = $rootScope.stoFrom ? stoTool + ' - ' + $rootScope.stoFrom : stoTool;
            if (!ctrl.wizardMode) {
                return;
            }
            TrackEventService.event(
                'Suite Usages',
                'SEO Project - Step - Set Locations', eventLabel
            );
            TrackEventService.gaV2Event(
                'project_wizard', {
                    step: 'Set Locations',
                    from: $rootScope.stoFrom,
                    type: stoTool
                }
            );
        }

        function availableCountries() {
            return CountriesService.all() || [];
        }

        function pickerCountries() {
            var query = String(vm.countryPickerSearch || '').trim().toLowerCase();
            return availableCountries().filter(function (country) {
                return !query ||
                    String(country.name || '').toLowerCase().indexOf(query) !== -1 ||
                    String(country.code || '').toLowerCase().indexOf(query) !== -1;
            });
        }

        function selectCountryFromPicker(country) {
            if (!country) {
                return;
            }
            vm.locationDraft.countryCode = country.code;
            vm.countryPickerSearch = '';
        }

        function firstAvailableCountryCode() {
            var countries = availableCountries();
            return countries.length ? countries[0].code : null;
        }

        function preferredCountryCode() {
            var existing = (ctrl.locations || []).filter(function (location) {
                return location && location.countryCode;
            })[0];
            return existing ? String(existing.countryCode).toUpperCase() : firstAvailableCountryCode();
        }

        function selectedDeviceIds() {
            return (vm.locationDraft.deviceIds || []).map(Number).filter(function (deviceId, index, values) {
                return (deviceId === 1 || deviceId === 2) && values.indexOf(deviceId) === index;
            }).sort();
        }

        function locationAlreadySelected(countryCode, searchEngineId, deviceId) {
            return !!countryCode && (ctrl.locations || []).some(function (location) {
                return String(location.countryCode).toUpperCase() === String(countryCode).toUpperCase() &&
                    Number(location.searchEngineId) === Number(searchEngineId) &&
                    Number(location.deviceId) === Number(deviceId);
            });
        }

        function selectedDevicesToAdd() {
            var countryCode = vm.locationDraft.countryCode;
            var searchEngineId = vm.locationDraft.searchEngineId;
            return selectedDeviceIds().filter(function (deviceId) {
                return !locationAlreadySelected(countryCode, searchEngineId, deviceId);
            });
        }

        function toggleDevice(deviceId) {
            if (Number(vm.locationDraft.searchEngineId) === 2 && Number(deviceId) === 2) {
                return;
            }
            var selected = selectedDeviceIds();
            var index = selected.indexOf(Number(deviceId));
            if (index === -1) {
                selected.push(Number(deviceId));
            } else {
                selected.splice(index, 1);
            }
            vm.locationDraft.deviceIds = selected.sort();
        }

        function deviceSelected(deviceId) {
            return selectedDeviceIds().indexOf(Number(deviceId)) !== -1;
        }

        function canAddLocation() {
            var devices = selectedDevicesToAdd();
            return !!(vm.planReady && !vm.planError && vm.locationDraft.countryCode && devices.length);
        }

        function isLimitExceeded() {
            return totalTracking() > Number(ctrl.availableLimit);
        }

        function addLocation() {
            if (!canAddLocation()) {
                showCustomToast('project.wizard.limits.notEnoughLocations', 'icon-x st-red');
                return;
            }
            selectedDevicesToAdd().forEach(function (deviceId) {
                ctrl.locations.push({
                    searchEngineId: Number(vm.locationDraft.searchEngineId),
                    countryCode: String(vm.locationDraft.countryCode).toUpperCase(),
                    deviceId: deviceId
                });
            });
        }

        function removeLocation(index) {
            if ((ctrl.locations || []).length <= 1) {
                showCustomToast('project.wizard.locations.atLeastOne', 'icon-x st-red');
                return;
            }
            ctrl.locations.splice(index, 1);
        }

        function totalTracking() {
            return Number(ctrl.keywords.length) * Math.max(1, (ctrl.locations || []).length);
        }

        function remainingTracking() {
            return Math.max(0, Number(ctrl.availableLimit) - totalTracking());
        }

        function countryName(countryCode) {
            var country = countryCode && CountriesService.getByCode(String(countryCode));
            return country ? country.name : countryCode;
        }

        function countryFlag(countryCode) {
            return '/assets/img/modules/flags/' + String(countryCode || '').toLowerCase() + '.png';
        }

        function locationEngine(location) {
            var searchEngineId = location && Number(location.searchEngineId);
            var searchEngine = vm.searchEngines.filter(function (engine) {
                return engine.id === searchEngineId;
            })[0];
            return searchEngine ? searchEngine.name : 'Google';
        }

        function searchEngineIcon(searchEngineId) {
            var id = Number(searchEngineId);
            var searchEngine = vm.searchEngines.filter(function (engine) {
                return engine.id === id;
            })[0];
            return searchEngine ? searchEngine.icon : vm.searchEngines[0].icon;
        }

        function locationDevice(location) {
            var deviceId = location && Number(location.deviceId);
            var device = vm.devices.filter(function (item) {
                return item.id === deviceId;
            })[0];
            return device ? device.name : 'Desktop';
        }

        function showCustomToast(string, classIcon) {
            $mdToast.show({
                template: '<md-toast layout="row" flex class="md-toast max-w">' +
                    '   <div class="p-t p-b"><i class="' + classIcon + ' m-r-sm"></i>' +
                    $translate.instant(string) + '</div>' +
                    '</md-toast>',
                hideDelay: 4000,
                position: 'top right',
                parent: angular.element('.toast-show')
            });
        }
    }

    controller.$inject = [
        '$scope',
        '$translate',
        '$mdToast',
        'CountriesService',
        'TrackEventService',
        '$rootScope',
    ];

    return {
        templateUrl: 'app/modules/project/wizard/steps/add-locations/add-locations.html',
        bindings: {
            locations: '=',
            keywords: '<',
            availableLimit: '<',
            planReady: '<',
            planError: '<',
            onRetryLimits: '&',
            wizardMode: '<'
        },
        controller: controller,
    };
});
